import { onMount } from 'solid-js'
import Footer from '/web/shared/aifans/Footer'
import { characterStore } from '/web/store'
import { AppSchema } from '/common/types'
import { Character } from '/common/types/library'
import HomeSpotlight from './sections/HomeSpotlight'
import PopularCreators from './sections/PopularCreators'
import StatsBand from './sections/StatsBand'
import PlatformOverview from './sections/PlatformOverview'
import CTAStrip from './sections/CTAStrip'
import StepsSection from './sections/StepsSection'
import Newsletter from './sections/Newsletter'
import HomeFAQ from './sections/HomeFAQ'
import { Meta, Title, Link } from '@solidjs/meta'

export default function Home() {
  const chars = characterStore((s) => ({
    list: s.characters.list,
    map: s.characters.list.reduce<Record<string, AppSchema.Character>>(
      (prev, curr) => Object.assign(prev, { [curr._id]: curr }),
      {}
    ),
    loaded: s.characters.loaded,
    loading: s.loading,
  }))

  onMount(() => {
    if (!chars.loaded) {
      characterStore.getCharacters()
    }
  })

  return (
    <>
      <Title>CosplayFans - Exclusive Cosplay Content, Live Chats & More</Title>
      <Meta
        name="description"
        content="Join CosplayFans.ai for premium cosplay experiences! Enjoy exclusive content, live chats, and custom ai generated images."
      />
      <Meta
        name="og:title"
        content="CosplayFans - Exclusive Cosplay Content, Live Chats & More"
      />
      <Meta
        name="og:description"
        content="Join CosplayFans.ai for premium cosplay experiences! Enjoy exclusive content, live chats, and custom ai generated images."
      />
      <Meta name="og:url" content="https://www.cosplayfans.ai" />
      <Link rel="canonical" href="https://www.cosplayfans.ai" />

      {/* Hero / Featured Creator */}
      <HomeSpotlight />

      {/* Stats Band */}
      <StatsBand />

      {/* Trending Creators */}
      <PopularCreators
        creators={chars.list.filter((c: Character) => c.category === 'trending').slice(0, 4)}
        title={
          <div class="flex items-end justify-between gap-4 flex-wrap">
            <div>
              <div class="cf-eyebrow mb-2">Trending Now</div>
              <h2 class="cf-h2">
                Top Creators{' '}
                <span class="cf-grad-text">This Week</span>
              </h2>
            </div>
            <a href="/top-creators" class="font-rajdhani text-xs font-bold uppercase tracking-[1.2px] text-[var(--cf-cyan)] hover:text-white">
              View All Creators →
            </a>
          </div>
        }
      />

      {/* Platform Overview */}
      <PlatformOverview />

      {/* CTA Strip */}
      <CTAStrip />

      {/* How It Works + Bonus Card */}
      <StepsSection />

      {/* Newsletter */}
      <Newsletter />

      {/* FAQ */}
      <HomeFAQ />

      <Footer />
    </>
  )
}
